import { addDays, daysBetween, formatDe } from './date.js';
export const TONE_OKLCH = {
    urgent: 'oklch(0.72 0.17 25)',
    soon: 'oklch(0.83 0.15 80)',
    fresh: 'oklch(0.8 0.14 145)',
    none: 'oklch(0.62 0.015 70)',
};
/** Dark ink that stays legible on top of the matching TONE_OKLCH swatch. */
export const TONE_INK = {
    urgent: 'oklch(0.2 0.04 25)',
    soon: 'oklch(0.2 0.04 80)',
    fresh: 'oklch(0.2 0.04 145)',
    none: 'oklch(0.2 0.01 70)',
};
export function toneFor(days) {
    if (days === null)
        return 'none';
    if (days <= 1)
        return 'urgent';
    if (days <= 7)
        return 'soon';
    return 'fresh';
}
export function labelFor(days) {
    if (days === null)
        return 'offen';
    if (days < 0)
        return days === -1 ? 'seit gestern' : `seit ${Math.abs(days)} Tagen`;
    if (days === 0)
        return 'heute';
    if (days === 1)
        return 'morgen';
    if (days < 7)
        return `${days} Tage`;
    if (days < 28) {
        const w = Math.round(days / 7);
        return w === 1 ? '1 Woche' : `${w} Wochen`;
    }
    const m = Math.round(days / 30);
    return m === 1 ? '1 Monat' : `${m} Monate`;
}
export function describeExpiry(bestBefore, shelfDays, today) {
    const days = bestBefore ? daysBetween(today, bestBefore) : null;
    const percentLeft = days === null || shelfDays <= 0
        ? 100
        : Math.max(0, Math.min(100, Math.round((days / shelfDays) * 100)));
    return {
        days,
        tone: toneFor(days),
        label: labelFor(days),
        dateLabel: bestBefore ? formatDe(bestBefore) : 'kein Datum',
        percentLeft,
    };
}
/**
 * Shelf life to snapshot on an item at insert time.
 *
 * Snapshotting matters: the progress bar is days-remaining over shelf-days, so
 * if someone later edits a category default in Settings, items already in the
 * fridge must not visually jump.
 */
export function shelfDaysFor(bestBefore, today, fallback) {
    if (!bestBefore)
        return fallback;
    const span = daysBetween(today, bestBefore);
    return span > 0 ? span : fallback;
}
export { addDays, daysBetween, formatDe };
